import type { Prototype } from "../prototype-types";

export const chrisHandelPrototypes: Prototype[] = [
  {
    id: "ch-01-editorial-marketplace",
    name: "01 - Editorial Marketplace",
    path: "/ch/01-editorial-marketplace",
    description:
      "Retailer web exploration of an editorial marketplace experience.",
    owner: "Chris Handel",
    createdAt: "2026-07-15",
    lastUpdated: "2026-07-15",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/8b3fca8fab9e73334823614bc04257404bca67950c98c801364193bff7d8f6eb.png",
    creationTool: "cursor",
  },
];
